import React, { useState, useEffect, Suspense } from 'react'
import { Link } from 'react-router-dom'
import SuspenseLoader from '../../../../components/suspense_loader/SuspenseLoader'

import './TabsAndPages.scss'

export const TabsAndPages = ({ pageData = {}, year = '' }) => {
    const [activeIndex, setActiveIndex] = useState(0)

    const shownTabsDataLength = pageData.filter(item => item.show_tab === true).length
    const showTabbingAnimation = activeIndex < shownTabsDataLength

    const activeTabPosition = showTabbingAnimation ? 100 * activeIndex : 0
    const activeTabWidth = showTabbingAnimation ? 100 / shownTabsDataLength : 0
    const activeTabOpacity = showTabbingAnimation ? 1 : 0

    const ActiveComponent = pageData[activeIndex].component

    useEffect(() => {
        pageData.forEach((item, i) => {
            if (item.active === true) setActiveIndex(i)
        })

        let links = document.querySelectorAll('.ripple_tab_link')

        for (var i = 0, len = links.length; i < len; i++) {
            links[i].addEventListener(
                'click',
                function(e) {
                    let targetEl = e.target
                    let inkEl = targetEl.querySelector('.ink')

                    if (inkEl) {
                        inkEl.classList.remove('animate_ripple')
                    } else {
                        inkEl = document.createElement('span')
                        inkEl.classList.add('ink')
                        inkEl.style.width = inkEl.style.height =
                            Math.max(targetEl.offsetWidth, targetEl.offsetHeight) + 'px'
                        targetEl.appendChild(inkEl)
                    }

                    inkEl.style.left = e.offsetX - inkEl.offsetWidth / 2 + 'px'
                    inkEl.style.top = e.offsetY - inkEl.offsetHeight / 2 + 'px'
                    inkEl.classList.add('animate_ripple')
                },
                false
            )
        }
    }, [])

    return (
        <React.Fragment>
            <div className="tabs_cont" id="tabs_cont">
                <div
                    className="active_tab_slider"
                    style={{
                        transform: `translate3d(${activeTabPosition}%, 0, 0)`,
                        width: `${activeTabWidth}%`,
                        opacity: activeTabOpacity,
                    }}
                ></div>

                <div className="tabs_cont_inner">
                    {pageData.map((item, i) => (
                        <React.Fragment key={item.page_name + i.toString()}>
                            {item.show_tab && (
                                <div className={`tab_cont ${item.active ? 'active' : ''}`}>
                                    <div
                                        className={`ripple_tab_link tab_cont_inner ${(item.active &&
                                            'active') ||
                                            ''}`}
                                    >
                                        <Link
                                            to={`/${item.league}/${item.sport}/${item.page}/${year}`}
                                            onClick={() => setActiveIndex(i)}
                                        >
                                            {item.display_name}
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>

            <Suspense fallback={<SuspenseLoader />}>
                <ActiveComponent />
            </Suspense>
        </React.Fragment>
    )
}
